import React from 'react';
import { MapPin, MessageCircle, Clock, Star } from 'lucide-react';
import { businessData } from '../data/mock';
import './Hero.css';

const Hero = () => {
  return (
    <section id="inicio" className="hero">
      <div className="hero__bg">
        <div className="hero__bg-gradient"></div>
        <div className="hero__bg-pattern"></div>
      </div>
      
      <div className="hero__container container">
        <div className="hero__content">
          <div className="hero__badge">
            <Star size={14} />
            <span>{businessData.reputation.rating} estrellas · {businessData.reputation.totalReviews} opiniones</span>
          </div>
          
          <h1 className="hero__title">
            Tu lugar para
            <span className="hero__title-highlight"> disfrutar</span>
            <br />buena cerveza
          </h1>
          
          <p className="hero__subtitle">
            Bar de cerveza artesanal en el corazón de Rosario. 
            Ambiente cálido, buena música y las mejores picadas para compartir.
          </p>
          
          <div className="hero__info">
            <div className="hero__info-item">
              <Clock size={18} />
              <span>Abre a las {businessData.schedule.opening}</span>
            </div>
            <div className="hero__info-item">
              <MapPin size={18} />
              <span>{businessData.address.street}, {businessData.address.city}</span>
            </div>
          </div>
          
          <div className="hero__actions">
            <a 
              href={businessData.googleMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              <MapPin size={18} />
              Cómo llegar
            </a>
            <a 
              href={`https://wa.me/${businessData.contact.whatsapp}?text=Hola! Quiero hacer una consulta sobre Boulevard Cervecitas`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              <MessageCircle size={18} />
              WhatsApp
            </a>
          </div>
        </div>
        
        <div className="hero__visual">
          <div className="hero__image-wrapper">
            <img 
              src={businessData.heroImage} 
              alt={`${businessData.name} - Bar de cerveza artesanal`}
              className="hero__image"
            />
            <div className="hero__image-glow"></div>
          </div>
        </div>
      </div>
      
      <div className="hero__scroll-indicator">
        <span>Descubrí más</span>
        <div className="hero__scroll-line"></div>
      </div>
    </section>
  );
};

export default Hero;
